export { PayrollReceiptWidget } from './payroll-receipt-widget';
